import { settings } from './settings';

const menuConfig = [
    {
        "type": 'item',
        "href": '/',
        "icon": 'home',
        "entity": '',
        "label": 'Dashboard',
        "hideForLevel": [3]
    },
    {
        "type": 'header',
        "href": '#',
        "icon": '',
        "entity": '',
        "label": 'Anagrafiche',
        "hideForLevel": [3]
    },
    {
        "type": 'folder',
        "href": '#',
        "icon": 'list',
        "entity": '',
        "label": 'Anagrafiche',
        "hideForLevel": [3],
        "items": [
            {
                "href": '/entity/customer',
                "label": 'Clienti',
                "entity": 'customer'
            },
            {
                "href": '/entity/customer_contacts',
                "label": 'Contatti clienti',
                "entity": 'customer_contacts'
            },
            {
                "href": '/entity/supplier',
                "label": 'Fornitori',
                "entity": 'supplier'
            },
            {
                "href": '/entity/supplier_contacts',
                "label": 'Contatti fornitori',
                "entity": 'supplier_contacts'
            },
            {
                "href": '/entity/sales_agent',
                "label": 'Agenti',
                "entity": 'sales_agent'
            },
            {
                "href": '/entity/designer',
                "label": 'Designer',
                "entity": 'designer'
            },
            {
                "href": '/entity/prescrittore',
                "label": 'Prescrittori',
                "entity": 'prescrittore'
            }
        ]
    },
    {
        "type": 'folder',
        "href": '#',
        "icon": 'box',
        "entity": '',
        "label": 'Articoli',
        "hideForLevel": [3],
        "items": [
            {
                "href": '/entity/item_model',
                "label": 'Articoli',
                "entity": 'item_model'
            },
            {
                "href": '/entity/item_model_family',
                "label": 'Raggruppamenti',
                "entity": 'item_model_family'
            },
            {
                "href": '/entity/catalog',
                "label": 'Cataloghi',
                "entity": 'catalog'
            },
            {
                "href": '/entity/item_model_suppliers',
                "label": 'Listino fornitori',
                "entity": 'item_model_suppliers'
            },
            {
                "href": '/entity/listino',
                "label": 'Listini',
                "entity": 'listino'
            }
        ]
    },
    {
        "type": 'item',
        "href": '/entity/gyv_mpm',
        "icon": 'table-list',
        "entity": '',
        "label": 'Distinta base',
        "hideForLevel": [3]
    },
    {
        "type": 'header',
        "href": '#',
        "icon": '',
        "entity": '',
        "label": 'Ordini',
        "hideForLevel": [3]
    },
    {
        "type": 'item',
        "href": '/page/MascheraProvvigioni',
        "icon": 'money-bill',
        "entity": '',
        "label": 'Maschera provvigioni',
        "hideForLevel": [3]
    },
    {
        "type": 'folder',
        "href": '#',
        "icon": 'folder',
        "entity": '',
        "label": 'Ciclo attivo',
        "hideForLevel": [3],
        "items": [
            
            {
                "href": '/entity/customer_offer',
                "label": 'Preventivi clienti',
                "entity": 'customer_offer'
            },
            {
                "href": '/entity/customer_order',
                "label": 'Ordini clienti',
                "entity": 'customer_order'
            },
            {
                "href": '/entity/gyv_open_customer_rows',
                "label": 'Area produzione',
                "entity": 'gyv_open_customer_rows'
            },
            {
                "href": '/entity/gyv_close_customer_rows',
                "label": 'Righe CHIUSE ordini clienti',
                "entity": 'gyv_close_customer_rows'
            },
            {
                "href": '/entity/gyv_pdc',
                "label": 'Area Preparazione PDC',
                "entity": 'gyv_pdc'
            },
            {
                "href": '/entity/shipping_plan',
                "label": 'Piani di carico',
                "entity": 'shipping_plan'
            },
            {
                "href": '/entity/gyv_customer_transport_document',
                "label": 'Documenti spedizione',
                "entity": 'gyv_customer_transport_document'
            },
            {
                "href": '/entity/customer_ddt',
                "label": 'DDT',
                "entity": 'customer_ddt'
            },
            {
                "href": '/entity/customer_invoices',
                "label": 'Fatture',
                "entity": 'customer_invoices'
            }
        ]
    },
    {
        "type": 'folder',
        "href": '#',
        "icon": 'folder',
        "entity": '',
        "label": 'Ciclo passivo',
        "hideForLevel": [3],
        "items": [
            {
                "href": '/entity/supplier_order',
                "label": 'Ordini fornitori',
                "entity": 'supplier_order'
            },
            {
                "href": '/entity/supplier_transport_document',
                "label": 'DDT fornitore',
                "entity": 'supplier_transport_document'
            },
            {
                "href": '/entity/gyv_supplier_order_rows_open',
                "label": 'Area produzione fornitore',
                "entity": 'gyv_supplier_order_rows_open'
            },
            {
                "href": '/entity/supplier_invoices_received',
                "label": 'Fatture passive ricevute',
                "entity": 'supplier_invoices_received',
                "requireSetting": 'fatturazione'
            }
        ]
    },
    {
        "type": 'folder',
        "href": '#',
        "icon": 'boxes-stacked',
        "entity": '',
        "label": 'MRP',
        "hideForLevel": [3],
        "items": [
            {
                "href": '/page/Mrp',
                "label": 'Calcola fabbisogni',
                "entity": 'customer_order_rows'
            },
            {
                "href": '/entity/gyv_mrp_order_list',
                "label": 'Lista bisogni completa',
                "entity": 'gyv_mrp_order_list'
            },
            {
                "href": '/entity/gyt_order_list_request',
                "label": 'Storico richieste',
                "entity": 'gyt_order_list_request'
            }
        ]
    },
    
    {
        "type": 'header',
        "href": '#',
        "icon": '',
        "entity": '',
        "label": 'Magazzino'
    },
    {
        "type": 'folder',
        "href": '#',
        "icon": 'warehouse',
        "entity": '',
        "label": 'Magazzino',
        "items": [
            {
                "href": '/page/LocationTree',
                "label": 'Albero magazzino',
                "entity": 'warehouse',
                "hideForLevel": [3],
            },
            {
                "href": '/page/SetParams',
                "label": 'Calcolo parametri magazzino',
                "entity": 'warehouse',
                "hideForLevel": [3],
            },
            {
                "href": '/page/Warehouse',
                "label": 'Carico / Scarico',
                "entity": 'warehouse'
            },
            {
                "href": '/entity/movement_scope',
                "label": 'Causali movimentazione',
                "entity": 'movement_scope',
                "hideForLevel": [3],
            },
            {
                "href": '/entity/gyv_stocks',
                "label": 'Giacenze',
                "entity": 'gyv_stocks'
            },
            {
                "href": '/entity/warehouse',
                "label": 'Magazzini',
                "entity": 'warehouse',
                "hideForLevel": [3],
            },
            {
                "href": '/entity/item_model_quantity',
                "label": 'Qta articoli per magazzino',
                "entity": 'item_model_quantity',
                "hideForLevel": [3],
            },
            {
                "href": '/entity/item_model_movement',
                "label": 'Storico movimentazioni',
                "entity": 'item_model_movement',
                "hideForLevel": [3],
            },
        ]
    },
    {
        "type": 'header',
        "href": '#',
        "icon": '',
        "entity": '',
        "label": 'Impostazioni',
        "hideForLevel": [3]
    },
    {
        "type": 'folder',
        "href": '#',
        "icon": 'wrench',
        "entity": '',
        "label": 'Altro',
        "hideForLevel": [3],
        "items": [
            {
                "href": '/entity/attributes',
                "label": 'Attributi',
                "entity": 'attributes'
            },
            {
                "href": '/entity/vat_condition',
                "label": 'Condizioni IVA',
                "entity": 'vat_condition'
            },
            {
                "href": '/entity/payment_condition',
                "label": 'Condizioni pagamento',
                "entity": 'payment_condition'
            },
            {
                "href": '/entity/contatore',
                "label": 'Contatori',
                "entity": 'contatore'
            },
            {
                "href": '/entity/payment_condition_group',
                "label": 'Gruppi condizioni pagamento',
                "entity": 'payment_condition_group'
            },
            {
                "href": '/entity/shipping_rates',
                "label": 'Tariffe di spedizione',
                "entity": 'shipping_rates'
            },
            {
                "href": '/entity/template_mail',
                "label": 'Template mail',
                "entity": 'template_mail'
            },
            {
                "href": '/entity/template',
                "label": 'Template stampe',
                "entity": 'template'
            },
        ]
    },
    
    {
        "type": 'folder',
        "href": '#',
        "icon": 'cog',
        "entity": '',
        "label": 'Impostazioni',
        "hideForLevel": [3],
        "items": [
            {
                "href": '/entity/bank',
                "label": 'Banche',
                "entity": 'bank'
            },
            {
                "href": '/entity/formulario',
                "label": 'Formulario',
                "entity": 'formulario'
            },
            {
                "href": '/entity/area_geografica',
                "label": 'Area geografica',
                "entity": 'area_geografica'
            },
            {
                "href": '/entity/glossario',
                "label": 'Glossario',
                "entity": 'glossario'
            },
            {
                "href": '/entity/incoterms',
                "label": 'Incoterms',
                "entity": 'incoterms'
            },
            {
                "href": '/entity/intestazioni',
                "label": 'Intestazioni',
                "entity": 'intestazioni'
            },
            {
                "href": '/entity/company_settings',
                "label": 'Impostazioni azienda',
                "entity": 'company_settings'
            },
            {
                "href": '/page/TemplateTags',
                "label": 'Tag Template Stampe',
                "entity": ''
            },
            {
                "href": '/page/CsvImport',
                "label": 'Import CSV',
                "entity": ''
            },
            {
                "href": '/entity/languages',
                "label": 'Lingue',
                "entity": 'languages'
            },
            {
                "href": '/entity/log',
                "label": 'Log di sistema',
                "entity": 'log'
            },
            {
                "href": '/entity/country',
                "label": 'Nazioni',
                "entity": 'country'
            },
            {
                "href": '/entity/person_role',
                "label": 'Ruoli contatto',
                "entity": 'person_role'
            },
            {
                "href": '/entity/measure_unit',
                "label": 'Unità di misura',
                "entity": 'measure_unit'
            },
            {
                "href": '/entity/forwarder',
                "label": 'Vettori',
                "entity": 'forwarder'
            }
        ]
    },
    {
        "type": 'header',
        "href": '#',
        "icon": '',
        "entity": '',
        "label": 'Utente'
    },
    {
        "type": 'item',
        "href": '/settings',
        "icon": 'user-gear',
        "entity": '',
        "label": 'Profilo'
    },
    {
        "type": 'folder',
        "href": '#',
        "icon": 'cogs',
        "entity": '',
        "label": 'Configurazione',
        "items": [
            {
                "type": 'item',
                "href": '/entity/user',
                "entity": 'user',
                "label": 'Utenti'
            },
            {
                "type": 'item',
                "href": '/entity/user_group',
                "entity": 'user_group',
                "label": 'Gruppi'
            },
            {
                "type": 'item',
                "href": '/entity/user_entity_saved_filters',
                "entity": 'user_entity_saved_filters',
                "label": 'Filtri salvati'
            },
            {
                "type": 'item',
                "href": '/entity/user_entity_preferences',
                "entity": 'user_entity_preferences',
                "label": 'Preferenze entità'
            },
        ]
    },
    {
        "type": 'item',
        "href": '/logout',
        "icon": 'arrow-right-from-bracket',
        "entity": '',
        "label": 'Logout'
    }

];

function filterBySetting(item) {
    if (item.requireSetting && !settings[item.requireSetting]) return false;
    return true;
}

export const menu = menuConfig.map(item => {
    if (item.type === 'folder' && item.items) {
        return { ...item, items: item.items.filter(filterBySetting) };
    }
    return item;
}).filter(filterBySetting);
